import { globalStyle, style } from '@vanilla-extract/css';

export const signupInput = style({
  backgroundColor: 'var(--input-background-color)',
  color: 'var(--input-text-color)',
});

export const signupSubmitButton = style({
  backgroundColor: 'var(--button-background-color)',
  color: 'var(--button-text-color)',
});

export const signupModalDialogContent = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'stretch',
  height: 'auto',
  '@media': {
    'only screen and (--mobile)': {
      width: '100%',
      height: 'auto',
      maxHeight: '90vh',
      overflowY: 'auto',
    },
  },
});

export const signupModalContentContainer = style({
  display: 'flex',
  margin: '0 auto',
  overflow: 'auto',
  position: 'relative',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  '@media': {
    'only screen and (--mobile)': {
      width: 'var(--mobile-width, 100%)',
      maxWidth: 'var(--mobile-max-width, 100%)',
      position: 'initial',
    },
  },
});

globalStyle(`${signupModalContentContainer}::-webkit-scrollbar`, {
  display: 'none',
});
